import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_promotion_details: { message: "idle" },
};

export const retrieve_promotion_details_Slice = createSlice({
 name: "retrieve_promotion_details",
 initialState,
 reducers: {
  success_retrieve_promotion_details: (state, action) => {
   state.retrieve_promotion_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_promotion_details: (state, action) => {
   state.retrieve_promotion_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_promotion_details: (state) => {
   state.retrieve_promotion_details = { status: app_consts.IDLE };
  },
  loading_retrieve_promotion_details: (state) => {
   state.retrieve_promotion_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_promotion_details, fail_retrieve_promotion_details, reset_retrieve_promotion_details, loading_retrieve_promotion_details } = retrieve_promotion_details_Slice.actions;

export default retrieve_promotion_details_Slice.reducer;